import React, { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import { components } from "react-select";
import { Spinner } from 'reactstrap';
import TimesheetPage from "../pages/projects/TimesheetPage";
// Lazy loading components
const Dashboard = lazy(() => import('../pages/reports/Audits/AuditTrends'));

//Error
const Alt404 = lazy(() => import('../pages/Authentication/Errors/Alt404'));
const Cover404 = lazy(() => import('../pages/Authentication/Errors/Cover404'));

//Catalog
const ProductList = lazy(() => import('../pages/Product/ProductList'));
const VendorProductList = lazy(() => import('../pages/vendorProduct/ProductList'));
const AddProduct = lazy(() => import('../pages/Product/AddProduct'));
const BulkUpload = lazy(() => import('../pages/Product/BulkUpload'));
const VendorAddProduct = lazy(() => import('../pages/vendorProduct/AddProduct'));
const AddBrand = lazy(() => import('../pages/brand/AddBrand'));
const BrandList = lazy(() => import('../pages/brand/BrandList'));
const AddAttribute = lazy(() => import('../pages/attribute/AddAttribute'));
const AttributeList = lazy(() => import('../pages/attribute/AttributeList'));
const AddCategory = lazy(() => import('../pages/category/AddCategory'));
const CategoryList = lazy(() => import('../pages/category/CategoryList'));
const VarientList = lazy(() => import('../pages/varient/VarientList'));
const AddVarient = lazy(() => import('../pages/varient/AddVarient'));
//Admin
const AddUser = lazy(() => import('../pages/admin/user/AddUser'));
const UserList = lazy(() => import('../pages/admin/user/UserList'));
const VendorList = lazy(() => import('../pages/vendor/VendorList'));
const AddVendor = lazy(() => import('../pages/vendor/AddVendor'));
const AddMaster = lazy(() => import('../pages/admin/master/AddMaster'))
const MasterList = lazy(() => import('../pages/admin/master/MasterList'))
const CountryList = lazy(() => import('../pages/admin/country/CountryList'))
const AddCountry = lazy(() => import('../pages/admin/country/AddCountry'))
const Countrycomponet = lazy(() => import('../pages/admin/country/Countrycomponet'))
const AddCustomer = lazy(() => import('../pages/admin/customer/AddCustomer'))
const CustomerSelectedOrder = lazy(() => import('../pages/admin/customer/CustomerSelectedOrder'))
const Orderlist = lazy(() => import('../pages/orders/OrderList'))
const AddOrder = lazy(() => import('../pages/orders/AddOrder'))
const ReturnOrder = lazy(() => import('../pages/orders/ReturnOrder'))
const Orderstabs = lazy(() => import('../pages/orders/Orderstabs'));
const PaymentStatus = lazy(() => import('../pages/admin/customer/PaymentSuccess'));
const CustomerPayScreen = lazy(() => import('../pages/admin/customer/CustomerPay'));

//Warehouse
const AddWarehouse = lazy(() => import('../pages/projects/Warehouse/WarehouseForm'));
const WarehouseList = lazy(() => import('../pages/projects/Warehouse/WarehouseList'));

//Entity
const EntityPage = lazy(() => import('../pages/Entity/EntityPage'));
const EntityList = lazy(() => import('../pages/Entity/EntityList'));


const CustomerList = lazy(() => import('../pages/admin/customer/CustomerList'))
const MenuList = lazy(() => import('../pages/admin/menu/MenuList'))
const SubMenuList = lazy(() => import('../pages/admin/menu/SubMenuList'))
const AddMenu = lazy(() => import('../pages/admin/menu/AddMenu'))
const GroupList = lazy(() => import('../pages/admin/groups/GroupList'));
const AddGroup = lazy(() => import('../pages/admin/groups/AddGroup'));
//webfeed
const Webfeedlist = lazy(() => import('../pages/webfeed/Webfeedlist'))
const Addwebfeed = lazy(() => import('../pages/webfeed/Addwebfeed'))

//Assets
const AddCampaign = lazy(() => import('../pages/Campaign/AddCampaign'))
const Assetstab = lazy(() => import('../pages/Assets/AssetInventory/Assetstab'))
const Tabs = lazy(() => import('../pages/Assets/AssetInventory/Tabs'))
const AddInventoryComponent = lazy(() => import('../pages/Assets/AssetInventory/AddInventoryComponent'))
const AssetCategoryList = lazy(() => import('../pages/Assets/AssetCategory/AssetCategoryList'))
const AddAssetCategory = lazy(() => import('../pages/Assets/AssetCategory/AddAssetCategory'));

const AssetMasterList = lazy(() => import('../pages/Assets/AssetMaster/AssetMasterList'));
const AddAssetMaster = lazy(() => import('../pages/Assets/AssetMaster/AddAssetMaster'));
const AssetInventory = lazy(() => import('../pages/Assets/AssetInventory/Asset'));
const AssetStatus = lazy(() => import('../pages/Assets/AssetInventory/AssetStatus'));
//Accounts
const Ledgerlist = lazy(() => import('../pages/Accounts/LedgerMaster/Ledgerlist'))
const AddLedger = lazy(() => import('../pages/Accounts/LedgerMaster/AddLedger'))
const TransationList = lazy(() => import('../pages/Accounts/Tansactions/TransactionList'))
const PaymentIn = lazy(() => import('../pages/Accounts/Tansactions/PaymentIn'))
const PaymentOut = lazy(() => import('../pages/Accounts/Tansactions/PaymentOut'))

//pos
const SessionList = lazy(() => import('../pages/oms/pos/SessionList'));
const PosCheckout = lazy(() => import('../pages/oms/pos/PosCheckout'));
//CMS
const AddPostCategory = lazy(() => import('../pages/cms/category/AddPostCategory'));
const PostCategoryList = lazy(() => import('../pages/cms/category/PostCategoryList'));
const AddPost = lazy(() => import('../pages/cms/post/AddPost'));
const PostList = lazy(() => import('../pages/cms/post/PostList'));
const Searchcomponent = lazy(() => import('../pages/cms/search/Searchcomponent'));
const Searchlist = lazy(() => import('../pages/cms/search/Searchlist'));
//invoice
const TaxinvoiceList = lazy(() => import("../pages/oms/taxinvoice/TaxinvoiceList"));
const TaxinvoiceComponent = lazy(() => import("../pages/oms/taxinvoice/TaxinvoiceComponent"))

//inventory
const PurhaseList = lazy(() => import("../pages/inventory/PurhaseList"))
const Tabscomponent = lazy(() => import("../pages/inventory/Tabscomponent"))
//projects
const ProjectList = lazy(() => import("../pages/projects/ProjectList"))
const AddProject = lazy(() => import("../pages/projects/AddProject"))
const ProjectTabs = lazy(() => import("../pages/projects/ProjectTabs"))
const BookUnit = lazy(() => import("../pages/projects/BookUnit"))
//social and marketing dashboard
const Socailandmarketingdashboard = lazy(() => import("../pages/Socialandmarketingdashboard/Dashboard"))

//Amenites
const AmenitesList = lazy(() => import("../pages/projects/Amenites/AmenitesList"))
const AddAmenites = lazy(() => import("../pages/projects/Amenites/AddAmenites"))

//Timesheets
const TimesheetList = lazy(() => import('../pages/projects/TimesheetList'))
//Hris
const StaffList = lazy(() => import("../pages/Hris/Staff/StaffList"))
const StaffTabs = lazy(() => import('../pages/Hris/Staff/StaffTabs'))
const Attendance = lazy(() => import('../pages/Hris/Attendence/Attendance'))
const LeavesList = lazy(() => import('../pages/Hris/Staff/LeaveRequest/LeavesList'))
const LeaveAprovalTabs = lazy(() => import('../pages/Hris/Staff/LeaveRequest/LeaveApprovalTabs'))
const AddLeave = lazy(() => import('../pages/Hris/Staff/LeaveRequest/AddLeave'))
const LeaveRequest = lazy(() => import('../pages/Hris/Staff/LeaveRequestManagement/LeavesList'))
const AddLeaveRequest = lazy(() => import('../pages/Hris/Staff/LeaveRequestManagement/AddLeave'))
const HrisStettings = lazy(() => import('../pages/Hris/Staff/HrisStettings/SettingTabs'))
const ExitrequestList = lazy(() => import('../pages/Hris/Staff/Exit Request/ExitrequestList'))
const ExitRequest = lazy(() => import('../pages/Hris/Staff/Exit Request/ExitRequest'))
const ExitApprovalTabs = lazy(() => import('../pages/Hris/Staff/Exit Request/ExitApprovalTabs'))
//CRM
const RatingList = lazy(() => import('../pages/crm/rating/Rating'))
const ComplainList = lazy(() => import('../pages/crm/complain/Complain'))
const AddComplain = lazy(() => import('../pages/crm/complain/AddComplain'))
const ComplainSetting = lazy(() => import('../pages/crm/complain/ComplainSetting'))
const Chat = lazy(() => import('../pages/crm/chats/Chat'))
const EnquiryForm = lazy(() => import('../pages/crm/EnquiryForm/EnquiryForm'));
const LeadsList = lazy(() => import('../pages/crm/EnquiryForm/LeadListTabs'));
const BulkLeadUpload = lazy(() => import('../pages/reports/UploadReport'));
const Task = lazy(()=> import("../pages/Tasks/index"));

const AgentList = lazy(() => import('../pages/crm/Agents/AgentList'));
const AddAgent = lazy(() => import('../pages/crm/Agents/AddAgent'));
//Reports
const DashboardManagement = lazy(() => import('../pages/reports/Dashbord/Dashboard'))
const AuditReport = lazy(() => import('../pages/reports/Audits/AuditTrends'))
const CollectionReport = lazy(() => import('../pages/reports/CollectionReport'))


//Checklist and Audits
const ChecklistList = lazy(() => import('../pages/Checklist/ManageChecklist/ChecklistList'))
const AddChecklist = lazy(() => import('../pages/Checklist/ManageChecklist/Checklist'))
const AddAudit = lazy(() => import('../pages/Checklist/MyAudits/AuditForm'))
const EditAudit = lazy(() => import('../pages/Checklist/MyAudits/AuditForm'))
const ViewAudit = lazy(() => import('../pages/Checklist/MyAudits/ViewAudit'))
const MyAuditList = lazy(() => import('../pages/Checklist/MyAudits/MyAuditList'))
const ChecklistCategoryList = lazy(() => import('../pages/Checklist/ManageCategories/ChecklistCategories'))

//Coupans
const Coupanlist = lazy(() => import('../pages/Coupans/Coupanlist'))
const Addcoupan = lazy(() => import('../pages/Coupans/Addcoupan'))
//stock
const StockComponent = lazy(() => import('../pages/stock/StockComponent'))
const ManageReports = lazy(() => import('../pages/stock/MangeReports'))
const StockReciverComponent = lazy(() => import('../pages/stock/StockReciverComponent'))
const PurchaseEntryList = lazy(() => import('../pages/stock/PurchaseEntryList'))
const StocktransferList = lazy(() => import('../pages/stock/StocktransferList'))
const StockReciverList = lazy(() => import('../pages/stock/StockReciverList'))
const PurchaseReturnEntryList = lazy(() => import('../pages/stock/PurchaseReturnEntryList'))
const PurchaseEntry = lazy(() => import('../pages/stock/PurchaseEntry'))
const PurchaseReturn = lazy(() => import('../pages/stock/PurchaseReturn'))

//supplier
const AddSupplier = lazy(() => import("../pages/admin/supplier/AddSupplier"));
const SupplierList = lazy(() => import("../pages/admin/supplier/SupplierList"));
//vendor settlememt
const VendorSettlement = lazy(() => import("../pages/vendorSettlememt/VendorSettlement"));

//Otp Routes
const ForgotPassword = lazy(() => import("../pages/Authentication/ForgotPassword"))
const OtpComponent = lazy(() => import("../pages/Authentication/OtpComponent"))
const ResetPassword = lazy(() => import("../pages/Authentication/ResetPassword"))
const ResendOtp = lazy(() => import("../pages/Authentication/ResendOtp"))
const OtpSentSuccess = lazy(() => import("../pages/Authentication/OtpSentSuccess"))

//Storfront
const SectionScreen = lazy(() => import('../pages/storefront/section/SectionScreen'))
const SectionList = lazy(() => import('../pages/storefront/section/SectionList'))
const AddBanner = lazy(() => import('../pages/storefront/banner/AddBanner'))

//faqs 
const FaqsComponent = lazy(() => import("../pages/admin/faqs/FaqsComponent"))
const FaqsList = lazy(() => import("../pages/admin/faqs/FaqsList"))
//producttracking
const Producttracking = lazy(() => import("../pages/productTracking/Producttracking"))

// public routes import components
const Login = lazy(() => import('../pages/Authentication/Login'));
const Register = lazy(() => import('../pages/Authentication/Register'));

//CMS
const AddPage = lazy(() => import('../pages/cms/SF_Pages/AddPages'));
const PagesList = lazy(() => import('../pages/cms/SF_Pages/PagesList'))
const PagemainComponent = lazy(() => import('../pages/cms/SF_Pages/PagemainComponent'))

const EnquiryLeadForm = lazy(() => import('../pages/crm/EnquiryFormLeads/EnquiryFormLead'));
const EnquiryLeadsList = lazy(() => import('../pages/crm/EnquiryFormLeads/LeadListTabsLead'));

const CostSheet = lazy(() => import("../pages/projects/Costsheets/Costsheets"))
const CostSheetList = lazy(() => import("../pages/projects/Costsheets/CostSheetList"))

 
const ItemMaster = lazy(() => import('../pages/Catalog/ItemMasterList'));
const AddItemMaster = lazy(() => import('../pages/Catalog/AddItemMaster'));

// Fallback UI for lazy-loaded components
const Loading = () => <div className="page-content d-flex align-items-center justify-content-center min-vh-100"><Spinner color="primary"> Loading... </Spinner></div>;

// marketing influencers

const AddInfluencer = lazy(() => import('../pages/marketing/influencers/AddInfluencer'))
const InfluencerList = lazy(() => import('../pages/marketing/influencers/InfluencerList'))

const UTMForm = lazy(() => import('../pages/marketing/utm_management/UTMDataForm'))
const UTMList = lazy(() => import('../pages/marketing/utm_management/UTMList'))

const SettingsPage = lazy(() => import("../pages/Marketing/SettingsPage"));

//careers
const AddJob = lazy(() => import("../pages/Careers/AddCareerJob"))
const CareersJobList = lazy(() => import("../pages/Careers/CarrersJobList"))

const UnitsInventoryReport = lazy(() => import("../pages/projects/UnitsInventoryReport"));
const LeadsReports = lazy(() => import("../pages/crm/EnquiryFormLeads/LeadsReports"));



// const CostSheet = lazy(() => import("../pages/projects/Costsheets/Costsheets"))
const PublicRoutes = [
  {
    path: "/",
    component: <Suspense fallback={<Loading />}> <Login /> </Suspense>
  },
  {
    path: "/forgot-password",
    component: <Suspense fallback={<Loading />}><ForgotPassword /></Suspense>
  },
  {
    path: "/verify-otp",
    component: <Suspense fallback={<Loading />}><OtpComponent /></Suspense>
  },

  {
    path: "/reset-password",
    component: <Suspense fallback={<Loading />}><ResetPassword /></Suspense>
  },
  {
    path: "/resend-otp",
    component: <Suspense fallback={<Loading />}><ResendOtp /></Suspense>
  },
  {
    path: "/otp-success",
    component: <Suspense fallback={<Loading />}><OtpSentSuccess /></Suspense>
  },
  {
    path: "/register",
    component: <Suspense fallback={<Loading />}> <Register /> </Suspense>
  },
];

const authProtectedRoutes = [
  {
    path: "/catlog/product",
    component: <Suspense fallback={<Loading />}> <ProductList /> </Suspense>
  },
  {
    path: "/catlog/addProduct/bulkUpload",
    component: <Suspense fallback={<Loading />}> <BulkUpload /> </Suspense>
  },
  {
    path: "/catlog/addProduct",
    component: <Suspense fallback={<Loading />}> <AddProduct /> </Suspense>
  },
  {
    path: "/catlog/addProduct/:slug",
    component: <Suspense fallback={<Loading />}> <AddProduct /> </Suspense>
  },
  {
    path: "/catlog/vendor/product",
    component: <Suspense fallback={<Loading />}> <VendorProductList /> </Suspense>
  },
  {
    path: "/catlog/vendor/addProduct",
    component: <Suspense fallback={<Loading />}> <VendorAddProduct /> </Suspense>
  },
  {
    path: "/catlog/vendor/addProduct/:slug",
    component: <Suspense fallback={<Loading />}> <VendorAddProduct /> </Suspense>
  },
  {
    path: "/catlog/addBrand",
    component: <Suspense fallback={<Loading />}> <AddBrand /> </Suspense>
  },
  {
    path: "/catlog/addBrand/:slug",
    component: <Suspense fallback={<Loading />}> <AddBrand /> </Suspense>
  },
  {
    path: "/catlog/brand",
    component: <Suspense fallback={<Loading />}> <BrandList /> </Suspense>
  },
  {
    path: "/admin/user",
    component: <Suspense fallback={<Loading />}> <UserList /> </Suspense>
  },
  {
    path: "/admin/addUser/:slug",
    component: <Suspense fallback={<Loading />}> <AddUser /> </Suspense>
  },
  {
    path: "/catlog/attribute",
    component: <Suspense fallback={<Loading />}> <AttributeList /> </Suspense>
  },
  {
    path: "/catlog/addAttribute",
    component: <Suspense fallback={<Loading />}> <AddAttribute /> </Suspense>
  },
  {
    path: "/dashboard",
    component: <Suspense fallback={<Loading />}> <Dashboard /> </Suspense>
  },
  //User
  {
    path: "/admin/user",
    component: <Suspense fallback={<Loading />}> <UserList /> </Suspense>
  },
  {
    path: "/admin/addUser",
    component: <Suspense fallback={<Loading />}> <AddUser /> </Suspense>
  },
  //STAFF
  {
    path: "/hris/stafflist",
    component: <Suspense fallback={<Loading />}><StaffList /></Suspense>
  },
  {
    path: "/hris/createstaff",
    component: <Suspense fallback={<Loading />}><StaffTabs /></Suspense>
  },
  {
    path: "/hris/createstaff/:slug",
    component: <Suspense fallback={<Loading />}><StaffTabs /></Suspense>
  },
  {
    path: "/hris/Attendance",
    component: <Suspense fallback={<Loading />}><Attendance /></Suspense>
  },
  {
    path: "/hris/staffleaves",
    component: <Suspense fallback={<Loading />}><LeavesList /></Suspense>
  },
  {
    path: "/hris/leaveapproval",
    component: <Suspense fallback={<Loading />}><LeaveAprovalTabs /></Suspense>
  },
  {
    path: "/hris/adminstaffleaves",
    component: <Suspense fallback={<Loading />}><AddLeave /></Suspense>
  },
  {
    path: "/hris/adminstaffleaves/:slug",
    component: <Suspense fallback={<Loading />}><AddLeave /></Suspense>
  },

  {
    path: "/hris/leaverequests",
    component: <Suspense fallback={<Loading />}><LeaveRequest /></Suspense>
  },
  {
    path: "/hris/addleaverequest",
    component: <Suspense fallback={<Loading />}><AddLeaveRequest /></Suspense>
  },
  {
    path: "/hris/addleaverequest/:slug",
    component: <Suspense fallback={<Loading />}><AddLeaveRequest /></Suspense>
  },
  {
    path: "/hris/settings",
    component: <Suspense fallback={<Loading />}><HrisStettings /></Suspense>
  },
  {
    path: "/hris/staffExitRequestList",
    component: <Suspense fallback={<Loading />}><ExitrequestList /></Suspense>
  },
  {
    path: "/hris/requestResignation",
    component: <Suspense fallback={<Loading />}><ExitRequest /></Suspense>
  },
  {
    path: "/hris/requestResignation/:slug",
    component: <Suspense fallback={<Loading />}><ExitRequest /></Suspense>
  },
  {
    path: "/hris/approveExit",
    component: <Suspense fallback={<Loading />}><ExitApprovalTabs /></Suspense>
  },
  //social and marketing dashboard  
  {
    path: "/social_marketing_dashboard",
    component: <Suspense fallback={<Loading />}> <Socailandmarketingdashboard /> </Suspense>
  },
    {
    path: "/report/dashboard",
    component: <Suspense fallback={<Loading />}> <Socailandmarketingdashboard /> </Suspense>
  },
  //Attribute
  {
    path: "/catlog/attribute",
    component: <Suspense fallback={<Loading />}> <AttributeList /> </Suspense>
  },
  {
    path: "/catlog/addAttribute",
    component: <Suspense fallback={<Loading />}> <AddAttribute /> </Suspense>
  },
  {
    path: "/catlog/addAttribute/:slug",
    component: <Suspense fallback={<Loading />}> <AddAttribute /> </Suspense>
  },
  //Vendor
  {
    path: "/admin/vendor",
    component: <Suspense fallback={<Loading />}> <VendorList /> </Suspense>
  },
  {
    path: "/admin/addvendor",
    component: <Suspense fallback={<Loading />}> <AddVendor /> </Suspense>
  },
{
  path: "/marketing/campagin_leads",
  component: <Suspense fallback={<Loading />}> <AddCampaign /> </Suspense>
},


  //Audits
  {
    path: "/audit/list",
    component: <Suspense fallback={<Loading />}><ChecklistList /></Suspense>
  },
  {
    path: "/audit/addaudit",
    component: <Suspense fallback={<Loading />}><AddAudit /></Suspense>
  },
  {
    path: "/audit/addaudit/:slug/:checklistid",
    component: <Suspense fallback={<Loading />}><EditAudit /></Suspense>
  },
  {
    path: "/audit/addchecklist",
    component: <Suspense fallback={<Loading />}><AddChecklist /></Suspense>
  },
  {
    path: "/audit/addchecklist/:slug",
    component: <Suspense fallback={<Loading />}><AddChecklist /></Suspense>
  },
  {
    path: "/audit/myauditlist",
    component: <Suspense fallback={<Loading />}><MyAuditList /></Suspense>
  },
  {
    path: "/audit/myauditlist/:slug",
    component: <Suspense fallback={<Loading />}><MyAuditList /></Suspense>
  },
  {
    path: "/audit/categories",
    component: <Suspense fallback={<Loading />}><ChecklistCategoryList /></Suspense>
  },
  {
    path: "/audit/viewaudit",
    component: <Suspense fallback={<Loading />}><ViewAudit /></Suspense>
  },
  {
    path: "/audit/viewaudit/:slug/:checklistid",
    component: <Suspense fallback={<Loading />}><ViewAudit /></Suspense>
  },

  //projects
  {
    path: "/projects/ProjectsList",
    component: <Suspense fallback={<Loading />}> <ProjectList /> </Suspense>
  },
  {
    path: "/projects/amenitiesList",
    component: <Suspense fallback={<Loading />}> <AmenitesList /> </Suspense>
  },
  {
    path: "/project/addProject",
    component: <Suspense fallback={<Loading />}> <ProjectTabs /> </Suspense>
  },
  {
    path: "/projects/addamenites",
    component: <Suspense fallback={<Loading />}> <AddAmenites /> </Suspense>
  },
  {
    path: "/projects/addamenites/:slug",
    component: <Suspense fallback={<Loading />}> <AddAmenites /> </Suspense>
  },
  {
    path: "/project/addProject/:slug",
    component: <Suspense fallback={<Loading />}> <ProjectTabs /> </Suspense>
  },
    {
    path: "/project/bookUnit/:slug",
    component: <Suspense fallback={<Loading />}> <BookUnit /> </Suspense>
  },
  //Variant
  {
    path: "/catlog/varients",
    component: <Suspense fallback={<Loading />}> <VarientList /> </Suspense>
  },
  {
    path: "/catlog/addVarients",
    component: <Suspense fallback={<Loading />}> <AddVarient /> </Suspense>
  },
  {
    path: "/catlog/addVarients/:slug",
    component: <Suspense fallback={<Loading />}> <AddVarient /></Suspense>
  },
  //coupan
  {
    path: "promotions/list",
    component: <Suspense fallback={<Loading />}> <Coupanlist /> </Suspense>
  },
  {
    path: "/promotions/AddPromotion",
    component: <Suspense fallback={<Loading />}> <Addcoupan /> </Suspense>
  },
  {
    path: "/promotions/AddPromotion/:slug",
    component: <Suspense fallback={<Loading />}> <Addcoupan /></Suspense>
  },
  // chats
  {
    path: "/crm/chat",
    component: <Suspense fallback={<Loading />}><Chat /></Suspense>
  },

  //Task
  {
    path: "/crm/task",
    component: <Suspense fallback={<Loading/>}><Task/></Suspense>
  }, 
  
  //stock
  {
    path: "/admin/stock_handover",
    component: <Suspense fallback={<Loading />}> <StockComponent /> </Suspense>
  },
  {
    path: "/admin/stock_recevier",
    component: <Suspense fallback={<Loading />}> <StockReciverComponent /> </Suspense>
  },
  {
    path: "/admin/stock_recevier/:slug",
    component: <Suspense fallback={<Loading />}> <StockComponent /> </Suspense>
  },
  {
    path: "/admin/entrylist",
    component: <Suspense fallback={<Loading />}> <PurchaseEntryList /> </Suspense>
  },
  {
    path: "/admin/stocktransferlist",
    component: <Suspense fallback={<Loading />}> <StocktransferList /> </Suspense>
  },
  {
    path: "/admin/stockreciverlist",
    component: <Suspense fallback={<Loading />}> <StockReciverList /> </Suspense>
  },
  {
    path: "/admin/purchasereturnList",
    component: <Suspense fallback={<Loading />}> <PurchaseReturnEntryList /> </Suspense>
  },
  {
    path: "/admin/managereports",
    component: <Suspense fallback={<Loading />}> <ManageReports /> </Suspense>
  },
  {
    path: "/admin/purchaseEntry",
    component: <Suspense fallback={<Loading />}> <PurchaseEntry /> </Suspense>
  },
  {
    path: "/admin/purchaseEntry/:slug",
    component: <Suspense fallback={<Loading />}> <PurchaseEntry /> </Suspense>
  },
  {
    path: "/admin/purchasereturn",
    component: <Suspense fallback={<Loading />}> <PurchaseReturn /> </Suspense>
  },

  //Master
  {
    path: "/admin/masterlist",
    component: <Suspense fallback={<Loading />}> <MasterList /> </Suspense>
  },
  {
    path: "/admin/addMaster",
    component: <Suspense fallback={<Loading />}> <AddMaster /> </Suspense>
  },
  {
    path: "/admin/addMaster/:slug",
    component: <Suspense fallback={<Loading />}> <AddMaster /> </Suspense>
  },
  //Country
  {
    path: "/admin/country",
    component: <Suspense fallback={<Loading />}> <CountryList /> </Suspense>
  },
  {
    path: "/admin/addCountry",
    component: <Suspense fallback={<Loading />}> <Countrycomponet /> </Suspense>
  },
  {
    path: "/admin/addCountry/:slug",
    component: <Suspense fallback={<Loading />}> <Countrycomponet /> </Suspense>
  },

  // Customer
  {
    path: "/admin/customer",
    component: <Suspense fallback={<Loading />}> <CustomerList /> </Suspense>
  },
  {
    path: "/admin/addCustomer",
    component: <Suspense fallback={<Loading />}> <AddCustomer /> </Suspense>
  },
  {
    path: "/admin/addCustomer/:slug",
    component: <Suspense fallback={<Loading />}> <AddCustomer /> </Suspense>
  },
  {
    path: "/admin/addCustomer/Order",
    component: <Suspense fallback={<Loading />}> <CustomerSelectedOrder /> </Suspense>
  },
 {
    path: "/admin/customer/paymentsuccess/:slug",
    component: <Suspense fallback={<Loading />}> <PaymentStatus /> </Suspense>
  },
   {
    path: "/admin/customer/customerpay",
    component: <Suspense fallback={<Loading />}> <AddCustomer /> </Suspense>
  },
   {
    path: "/admin/customer/customerpay/:slug",
    component: <Suspense fallback={<Loading />}> <CustomerPayScreen /> </Suspense>
  },
  {
    path: "/catlog/producttracking",
    component: <Suspense fallback={<Loading />}> <Producttracking /> </Suspense>
  },
  //Accounts
  {
    path: "/accounts/ledger",
    component: <Suspense fallback={<Loading />}> <Ledgerlist /> </Suspense>
  },
  {
    path: "/ledger/addledger",
    component: <Suspense fallback={<Loading />}> <AddLedger /> </Suspense>
  },
  {
    path: "/ledger/addledger/:slug",
    component: <Suspense fallback={<Loading />}> <AddLedger /></Suspense>
  },
  {
    path: "/accounts/transactions",
    component: <Suspense fallback={<Loading />}><TransationList /> </Suspense>
  },
  {
    path: "/accounts/transactions/:slug",
    component: <Suspense fallback={<Loading />}><PaymentIn /> </Suspense>
  },

  {
    path: "/accounts/paymentin",
    component: <Suspense fallback={<Loading />}><PaymentIn /> </Suspense>
  },
  {
    path: "/accounts/paymentin/:slug",
    component: <Suspense fallback={<Loading />}><PaymentIn /> </Suspense>
  },
  {
    path: "/accounts/paymentout",
    component: <Suspense fallback={<Loading />}><PaymentOut /> </Suspense>
  },
  {
    path: "/accounts/paymentout/:slug",
    component: <Suspense fallback={<Loading />}><PaymentOut /> </Suspense>
  },

  //Assets
  // {
  //     path: "/asset/invoicelist",
  //     component: <Suspense fallback={<Loading/>}><Assetstab/> </Suspense>
  //   },
  {
    path: "/asset/invoicelist",
    component: <Suspense fallback={<Loading />}><Tabs /> </Suspense>
  },
  {
    path: "/asset/addassetinventory",
    component: <Suspense fallback={<Loading />}><AddInventoryComponent /> </Suspense>
  },
  {
    path: "/asset/addassetinventory/:slug",
    component: <Suspense fallback={<Loading />}><AddInventoryComponent /> </Suspense>
  },
  {
    path: "/assets/category",
    component: <Suspense fallback={<Loading />}><AssetCategoryList /> </Suspense>
  },
  {
    path: "/asset/addAssetCategory",
    component: <Suspense fallback={<Loading />}><AddAssetCategory /> </Suspense>
  },
  {
    path: "/asset/addAssetCategory/:slug",
    component: <Suspense fallback={<Loading />}><AddAssetCategory /> </Suspense>
  },
  {
    path: "/asset/assetlist",
    component: <Suspense fallback={<Loading />}><AssetMasterList /> </Suspense>
  },
  {
    path: "/asset/addasset",
    component: <Suspense fallback={<Loading />}><AddAssetMaster /> </Suspense>
  },
  {
    path: "/asset/addasset/:slug",
    component: <Suspense fallback={<Loading />}><AddAssetMaster /> </Suspense>
  },

  {
    path: "/asset/addassetinventory/:slug",
    component: <Suspense fallback={<Loading />}><AssetInventory /> </Suspense>
  },
  {
    path: "/asset/asignment/:slug",
    component: <Suspense fallback={<Loading />}><AssetStatus /> </Suspense>
  },

  //orders
  {
    path: "/order/list",
    component: <Suspense fallback={<Loading />}><Orderstabs /></Suspense>
  },
  {
    path: "/webfeed/list",
    component: <Suspense fallback={<Loading />}><Webfeedlist /></Suspense>
  },
  {
    path: "/webfeed/add",
    component: <Suspense fallback={<Loading />}><Addwebfeed /></Suspense>
  },
  {
    path: "/webfeed/add/:slug",
    component: <Suspense fallback={<Loading />}><Addwebfeed /></Suspense>
  },
  {
    path: "/order/addOrder",
    component: <Suspense fallback={<Loading />}> <AddOrder /></Suspense>
  },
  {
    path: "/order/addOrder/:slug",
    component: <Suspense fallback={<Loading />}> <AddOrder /></Suspense>
  },
  {
    path: "/order/return/:slug",
    component: <Suspense fallback={<Loading />}> <ReturnOrder /></Suspense>
  },

  {
    path: "/order/taxinvoicelist",
    component: <Suspense fallback={<Loading />}> <TaxinvoiceList /></Suspense>
  },
  {
    path: "/order/porformainvoicelist",
    component: <Suspense fallback={<Loading />}> <TaxinvoiceList /></Suspense>
  },
  {
    path: "/order/quotelist",
    component: <Suspense fallback={<Loading />}> <TaxinvoiceList /></Suspense>
  },
  {
    path: "/order/taxinvoice",
    component: <Suspense fallback={<Loading />}> <TaxinvoiceComponent /></Suspense>
  },
  {
    path: "/order/porformainvoice",
    component: <Suspense fallback={<Loading />}> <TaxinvoiceComponent /></Suspense>
  },
  {
    path: "/order/porformainvoice/:slug",
    component: <Suspense fallback={<Loading />}> <TaxinvoiceComponent /></Suspense>
  },
  {
    path: "/order/quote",
    component: <Suspense fallback={<Loading />}> <TaxinvoiceComponent /></Suspense>
  },
  {
    path: "/order/quote/:slug",
    component: <Suspense fallback={<Loading />}> <TaxinvoiceComponent /></Suspense>
  },
  {
    path: "/order/taxinvoice/:slug",
    component: <Suspense fallback={<Loading />}> <TaxinvoiceComponent /></Suspense>
  },

  //inventory
  {
    path: "/inventory/list",
    component: <Suspense fallback={<Loading />}> <PurhaseList /> </Suspense>
  },
  {
    path: "/inventory/add",
    component: <Suspense fallback={<Loading />}> <Tabscomponent /> </Suspense>
  },
  {
    path: "/inventory/add/:slug",
    component: <Suspense fallback={<Loading />}> <Tabscomponent /> </Suspense>
  },
  {
    path: "/inventory/add/:slug/:slug1",
    component: <Suspense fallback={<Loading />}> <Tabscomponent /> </Suspense>
  },
  //Ticket category
  {
    path: "/crm/addTicketCategory",
    component: <Suspense fallback={<Loading />}> <AddCategory /> </Suspense>
  },
  {
    path: "/crm/addTicketCategory/:slug",
    component: <Suspense fallback={<Loading />}> <AddCategory /> </Suspense>
  },
  {
    path: "/crm/ticketCategory",
    component: <Suspense fallback={<Loading />}> <CategoryList /> </Suspense>
  },
  //Vendor
  {
    path: "/catlog/vendor",
    component: <Suspense fallback={<Loading />}> <CategoryList /> </Suspense>
  },
  {
    path: "/admin/vendor",
    component: <Suspense fallback={<Loading />}><VendorList /></Suspense>
  },
  {
    path: "/admin/addVendor",
    component: <Suspense fallback={<Loading />}><AddVendor /></Suspense>
  },
  {
    path: "/admin/addVendor/:slug",
    component: <Suspense fallback={<Loading />}><AddVendor /></Suspense>
  },
//campaign



  //Menu
  {
    path: "/admin/menu",
    component: <Suspense fallback={<Loading />}><MenuList /></Suspense>
  },
  {
    path: "/admin/menu/submenu/:slug",
    component: <Suspense fallback={<Loading />}><SubMenuList /></Suspense>
  },
  {
    path: "/admin/addMenu",
    component: <Suspense fallback={<Loading />}><AddMenu /></Suspense>
  },
  {
    path: "/admin/addMenu/:slug",
    component: <Suspense fallback={<Loading />}><AddMenu /></Suspense>
  },
  //Group
  {
    path: "/admin/Group",
    component: <Suspense fallback={<Loading />}><GroupList /></Suspense>
  },
  {
    path: "/admin/adduserGroup",
    component: <Suspense fallback={<Loading />}><AddGroup /></Suspense>
  },
  {
    path: "/admin/adduserGroup/:slug",
    component: <Suspense fallback={<Loading />}><AddGroup /></Suspense>
  },
  //Post Category
  {
    path: "/cms/Category",
    component: <Suspense fallback={<Loading />}><PostCategoryList /></Suspense>
  },
  {
    path: "/cms/addCategory",
    component: <Suspense fallback={<Loading />}><AddPostCategory /></Suspense>
  },
  {
    path: "/cms/addCategory/:slug",
    component: <Suspense fallback={<Loading />}><AddPostCategory /></Suspense>
  },
  // vendorsettlememt
  {
    path: "/order/VendorSettlement",
    component: <Suspense fallback={<Loading />}><VendorSettlement /></Suspense>
  },

  //Post
  {
    path: "/cms/Post",
    component: <Suspense fallback={<Loading />}><PostList /></Suspense>
  },
  {
    path: "/cms/addPost",
    component: <Suspense fallback={<Loading />}><AddPost /></Suspense>
  },
  {
    path: "/cms/addPost/:slug",
    component: <Suspense fallback={<Loading />}><AddPost /></Suspense>
  },
  //Search
  {
    path: "/cms/searchkeywords",
    component: <Suspense fallback={<Loading />}><Searchlist /></Suspense>
  },
  {
    path: "/cms/addSearchkeywords",
    component: <Suspense fallback={<Loading />}><Searchcomponent /></Suspense>
  },
  {
    path: "/cms/addSearchkeywords/:slug",
    component: <Suspense fallback={<Loading />}><Searchcomponent /></Suspense>
  },
  //Rating
  {
    path: "/crm/rating",
    component: <Suspense fallback={<Loading />}><RatingList /></Suspense>
  },
  //Rating
  {
    path: "/storefront/section",
    component: <Suspense fallback={<Loading />}><SectionList /></Suspense>
  },
  {
    path: "/storefront/addSection",
    component: <Suspense fallback={<Loading />}><SectionScreen /></Suspense>
  },
  {
    path: "/storefront/addSection/:slug",
    component: <Suspense fallback={<Loading />}><SectionScreen /></Suspense>
  },
  {
    path: "/storefront/Banner",
    component: <Suspense fallback={<Loading />}><AddBanner /></Suspense>
  },

  //Complain
  {
    path: "/crm/complaint",
    component: <Suspense fallback={<Loading />}><ComplainList /></Suspense>
  },
  {
    path: "/crm/complaint/:slug",
    component: <Suspense fallback={<Loading />}><ComplainList /></Suspense>
  },
  {
    path: "/crm/addComplaint",
    component: <Suspense fallback={<Loading />}><AddComplain /></Suspense>
  },
  {
    path: "/crm/addComplaint/:slug",
    component: <Suspense fallback={<Loading />}><AddComplain /></Suspense>
  },
  {
    path: "/crm/sla",
    component: <Suspense fallback={<Loading />}><ComplainSetting /></Suspense>
  },
  
//   //Enquiry form (Ira)
   {
    path: "/crm/enquiryform",
    component: <Suspense fallback={<Loading />}><EnquiryForm/></Suspense>
  },
    {
    path: "/crm/uploadleads",
    component: <Suspense fallback={<Loading />}><BulkLeadUpload/></Suspense>
  },
  {
    path: "/crm/leadsList",
    component: <Suspense fallback={<Loading />}><LeadsList/></Suspense>
  },
 {
    path: "/crm/enquiryform/:slug",
    component: <Suspense fallback={<Loading />}><EnquiryForm/></Suspense>
  },
  //Agent
  {
    path: "/crm/agentslist",
    component: <Suspense fallback={<Loading />}><AgentList/></Suspense>
  },
  {
    path: "/crm/addagent",
    component: <Suspense fallback={<Loading />}><AddAgent/></Suspense>
  },
  {
    path: "/crm/addagent/:slug",
    component: <Suspense fallback={<Loading />}><AddAgent/></Suspense>
  },



  //faqs

  {
    path: "/admin/addFaq",
    component: <Suspense fallback={<Loading />}> <FaqsComponent /> </Suspense>
  },
  {
    path: "/admin/addFaq/:slug",
    component: <Suspense fallback={<Loading />}> <FaqsComponent /> </Suspense>
  },
  {
    path: "/admin/faqs",
    component: <Suspense fallback={<Loading />}> <FaqsList /> </Suspense>
  },

  // Supplier
  {
    path: "/admin/supplier",
    component: (<Suspense fallback={<Loading />}><SupplierList /></Suspense>),
  },
  {
    path: "/admin/addSupplier",
    component: (<Suspense fallback={<Loading />}><AddSupplier /></Suspense>
    ),
  },
  {
    path: "/admin/addSupplier/:slug",
    component: (
      <Suspense fallback={<Loading />}><AddSupplier /></Suspense>
    ),
  },
  //pos
  {
    path: "/pos/sessionlist",
    component: <Suspense fallback={<Loading />}><SessionList /></Suspense>
  },
  {
    path: "/pos/poscheckout",
    component: <Suspense fallback={<Loading />}><PosCheckout /></Suspense>
  },




  //Global
  {
    path: "/index",
    component: <Suspense fallback={<Loading />}> <Dashboard /> </Suspense>
  },
  {
    path: "/",
    component: <Suspense fallback={<Loading />}> <Dashboard /> </Suspense>
  },
  {
    path: "/error401",
    component: <Suspense fallback={<Loading />}> <Alt404 /> </Suspense>
  },
  {
    path: "/error404",
    component: <Suspense fallback={<Loading />}> <Cover404 /> </Suspense>
  },
  { path: "*", component: <Navigate to="/error404" /> },


  //Reports
  {
    path: "/reports/dashboard",
    component: <Suspense fallback={<Loading />}><DashboardManagement /> </Suspense>
  },
  {
    path: "/reports/auditreport",
    component: <Suspense fallback={<Loading />}><AuditReport /> </Suspense>
  },
    {
    path: "/reports/collection",
    component: <Suspense fallback={<Loading />}>< CollectionReport/> </Suspense>
  },
  // PageList
  // {
  //   path: "/cms/page",
  //   component: <Suspense fallback={<Loading />}><PageList /> </Suspense>
  // },
  // {
  //   path: "/cms/page/addPages",
  //   component: <Suspense fallback={<Loading />}><AddPage /> </Suspense>
  // },
  {
    path: "/cms/page",
    component: <Suspense fallback={<Loading />}><PagesList /></Suspense>
  },
  {
    path: "/cms/page/addPages",
    component: <Suspense fallback={<Loading />}><PagemainComponent /></Suspense>
  },
  {
    path: "/cms/page/addPages/:slug",
    component: <Suspense fallback={<Loading />}><PagemainComponent /></Suspense>
  },

  //   //Lead Enquiry form (new)
   {
    path: "/crm/enquiryLeadForm",
    component: <Suspense fallback={<Loading />}><EnquiryLeadForm/></Suspense>
  },
    {
    path: "/crm/uploadenquiryleads",
    component: <Suspense fallback={<Loading />}><BulkLeadUpload/></Suspense>
  },
  {
    path: "/crm/enquiryLeadsList",
    component: <Suspense fallback={<Loading />}><EnquiryLeadsList/></Suspense>
  },
 {
    path: "/crm/enquiryLeadForm/:slug",
    component: <Suspense fallback={<Loading />}><EnquiryLeadForm/></Suspense>
  },

  //Warehouse
  {
    path: "/admin/Warehouse",
    component: <Suspense fallback={<Loading />}><WarehouseList /></Suspense>
  },
  {
    path: "/admin/addWarehouse",
    component: <Suspense fallback={<Loading />}><AddWarehouse /></Suspense>
  },
  {
    path: "/admin/addWarehouse/:slug",
    component: <Suspense fallback={<Loading />}><AddWarehouse /></Suspense>
  },
   {
    path: "/crm/timesheets",
    component: <Suspense fallback={<Loading />}><TimesheetList /></Suspense>
  },
  {
    path: "/crm/timesheet/addTimesheet",
    component: <Suspense fallback={<Loading />}><TimesheetPage /></Suspense>
  },
  
  {
    path: "/marketing/influencer",
    component: <Suspense fallback={<Loading />}><InfluencerList /></Suspense>
  },
  {
    path: "/marketing/addinfluencer/:slug",
    component: <Suspense fallback={<Loading />}><AddInfluencer /></Suspense>
  },
  {
    path: "/marketing/addinfluencer",
    component: <Suspense fallback={<Loading />}><AddInfluencer /></Suspense>
  },
    {
    path: "/marketing/utmmanagement",
    component: <Suspense fallback={<Loading />}><UTMList /></Suspense>
  },
      {
    path: "/marketing/addutmmanagement",
    component: <Suspense fallback={<Loading />}><UTMForm /></Suspense>
  },
       {
    path: "/marketing/addutmmanagement/:slug",
    component: <Suspense fallback={<Loading />}><UTMForm /></Suspense>
  },
{
    path: "/marketing/settings/",
    component: <Suspense fallback={<Loading />}><SettingsPage /></Suspense>
  },
  {
    path: "/careers/managecareers",
    component: <Suspense fallback={<Loading />}><CareersJobList /></Suspense>
  },

  //Item Master
  {
    path: "/catalog/itemmaster",
    component: <Suspense fallback={<Loading />}><ItemMaster /></Suspense>
  },
  {
    path: "/catalog/additemmaster",
    component: <Suspense fallback={<Loading />}><AddItemMaster /></Suspense>
  },
  {
    path: "/catalog/additemmaster/:slug",
    component: <Suspense fallback={<Loading />}><AddItemMaster /></Suspense>
  },
  // /reports/unitsinventory
{
    path: "/reports/unitsinventory",
    component: <Suspense fallback={<Loading />}><UnitsInventoryReport /></Suspense>
  },

   {
    path: "/projects/CostSheet",
    component: <Suspense fallback={<Loading />}><CostSheetList /></Suspense>
  },

  {
    path: "/projects/addCostSheet/:slug",
    component: <Suspense fallback={<Loading />}> <CostSheet /> </Suspense>
  },
  {
    path: "/projects/addCostSheet",
    component: <Suspense fallback={<Loading />}> <CostSheet /> </Suspense>
  },
  {
    path: "/reports/leadReport",
    component: <Suspense fallback={<Loading />}> <LeadsReports /> </Suspense>
  },

//Entity
  {
    path: "/admin/entityList",
    component: <Suspense fallback={<Loading />}><EntityList /></Suspense>
  },
  {
    path: "/admin/addEntity",
    component: <Suspense fallback={<Loading />}><EntityPage /></Suspense>
  },
  {
    path: "/admin/addEntity/:slug",
    component: <Suspense fallback={<Loading />}><EntityPage /></Suspense>
  },

];

export { authProtectedRoutes, PublicRoutes };
